import React from "react";
import useOtpLogin from "../../pages/UseOtpLogin/useOtpLogin";
import LoginForm from "./LoginForm";

const modalCloseHandler = () => {};
const LoginPage: React.FC = () => {
    
  const otpLoginEnabled = window.location.pathname === '/account/auth/otp';
  useOtpLogin(
    modalCloseHandler,
    otpLoginEnabled ? window.location.pathname : undefined
  );

  return (
      <div>
        {!otpLoginEnabled ? (
          <LoginForm modalCloseHandler={modalCloseHandler} />
        ) : null}
      </div>
  );
}
  export default LoginPage;
